// base
import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import TopBalanceComponentTable from "./TopBalanceComponentTable";

const TopBalanceComponent = (props) => {
  return <TopBalanceComponentTable props={props} />;
};

TopBalanceComponent.defaultProps = {
  totalBalance: 0,
  totalAccounts: 0,
  accountList: [],
  type: "full",
  pageNum: 1,
  pageSize: 25,
};

export default TopBalanceComponent;
